import React from 'react';
import './InteractiveSlideContent.scss';

const InteractiveSlideContent = ({ slide }) => {
    return <div className="interactive-slide">
        <iframe src={`/iframe/${slide.interactive}.html`}></iframe>
    </div>
}
export default InteractiveSlideContent;
